<section
  class="ngx-json-viewer"
  data-testid="json-viewer-container"
>
  @for (segment of segments(); track segment) {
    <section
      [ngClass]="['segment', 'segment-type-' + segment.type]"
      [attr.data-testid]="'json-segment-' + segment.key"
    >
      <section
        [ngClass]="{
          'segment-main': true,
          'expandable': isExpandable(segment),
          'expanded': segment.expanded,
        }"
        [attr.data-testid]="'json-segment-main-' + segment.key"
        (click)="toggle(segment)"
      >
        @if (isExpandable(segment)) {
          <div
            [attr.data-testid]="'json-toggler-' + segment.key"
            class="toggler"
          ></div>
        }
        <span
          [attr.data-testid]="'json-key-' + segment.key"
          class="segment-key"
          >{{ segment.key }}</span
        >
        <span
          class="segment-separator"
          data-testid="json-separator"
          >:
        </span>
        @if (!segment.expanded || !isExpandable(segment)) {
          <span
            [attr.data-testid]="'json-value-' + segment.key"
            class="segment-value"
            >{{ segment.description }}</span
          >
        }
      </section>
      @if (segment.expanded && isExpandable(segment)) {
        <section
          [attr.data-testid]="'json-children-' + segment.key"
          class="children"
        >
          <flx-json-viewer
            [json]="segment.value"
            [expanded]="expanded()"
            [depth]="depth()"
            [_currentDepth]="_currentDepth() + 1"
            [attr.data-testid]="'json-viewer-nested-' + segment.key"
          ></flx-json-viewer>
        </section>
      }
    </section>
  }
</section>
